<template style="">
  <div class="Material_management_edit">
    <el-form label-width="80px" :model="ruleForm" ref="ruleForm" style="padding-top: 20px;">
      <el-form-item label="标题" prop="MaterialName">
        <el-input style="width: 300px;" v-model="ruleForm.MaterialName" placeholder="请输入轮播图标题"></el-input>
      </el-form-item>
      
      <el-form-item label="上传图片" style="height: 180px;">
        <el-upload :on-change="handleChange" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" accept=".jpg, .jpeg, .png">
          <img v-if="imageUrl" :src="imageUrl" class="avatar"/>
          <i v-else class="el-icon-plus avatar-uploader-icon">
            <span style="font-size: 16px;">点击选择文件</span>
          </i>
        </el-upload>
        <p style="margin-left: 240px;color: #606266;">请发布与网站主题相关的图片，图片大小需控制在500K以内 文件格式请用.jpg .png .jpeg 建议比例：2.5:1</p>
      </el-form-item>

      <!--1为普测2为咨询3为访谈4为咨询师列表5活动6教育-->
      <el-form-item label="内部跳转">
        <el-select v-model="ruleForm.Type" placeholder="请选择类型">
          <el-option label="普测"       value ="1"></el-option>
          <el-option label="咨询"       value ="2"></el-option>
          <el-option label="访谈"       value ="3"></el-option>
          <el-option label="咨询师列表"  value ="4"></el-option>
          <el-option label="活动"       value ="5"></el-option>
          <el-option label="教育"       value ="6"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="发布对象">
        <el-radio-group v-model="ruleForm.SourceFlg">
          <el-radio label="1">宣传科普轮播图</el-radio>
          <el-radio label="2">app首页轮播图</el-radio>
          <el-radio label="3">心身</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="外部链接">
        <el-input style="width: 300px;" v-model="ruleForm.JumpContentLink" placeholder="请输入外部链接"></el-input>
      </el-form-item>

      <el-form-item label="语言">
        <el-radio-group v-model="ruleForm.ChineseAndEnglish">
          <el-radio label="1">中</el-radio>
          <el-radio label="2">英</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- <el-form-item label="是否启用">
        <el-switch v-model="ruleForm.IsActive"></el-switch>
      </el-form-item> -->

      <el-form-item label="定时发送">
        <el-radio-group v-model="timisngs">
          <el-radio label="1">否</el-radio>
          <el-radio label="2">是</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="timisngs == '2'" label="定时时间">
        <el-date-picker  v-model="ScheduledRelease" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss"  type="datetime" placeholder="选择日期时间" :picker-options="pickerOptions" @change="handleDateTimeChange">
          </el-date-picker>
      </el-form-item>
        <el-form-item label="审核意见" v-if="state==1">
        <el-radio-group v-model="AuditStatus">
          <el-radio label="1">通过</el-radio>
          <el-radio label="2">驳回</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="AuditStatus==2 && state==1" label="驳回原因">
        <el-input type="textarea" v-model="ReasonRejection" :autosize="{ minRows: 2}"></el-input>
      </el-form-item>

      <el-form-item style="padding-bottom: 30px;" v-if="state==1">
        <el-button type="primary" :loading="iscontinuous" @click="submitForm('ruleForm')">保存</el-button>
      </el-form-item>
      <el-form-item v-else> 
        <el-button type="primary" :loading="iscontinuous" @click="submitForm('ruleForm')">确定</el-button>
      </el-form-item>

    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return { 
      imageUrl: "",
      pictureFile: "",
      iscontinuous:false,
      ruleForm: {
        MaterialName: "",//图片标题
        Type:'',
        ChineseAndEnglish:'1',
        IsActive:1,
        SourceFlg:'1',
        JumpContentLink:''
      },
      timisngs:'',
      ScheduledRelease:'',
      state:0,
      AuditStatus:'',
      ReasonRejection:'',
    }
  },
  // ==== 新增计算属性 ====
  computed: {
    pickerOptions() {
      return {
        disabledDate: (time) => {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        },
        selectableRange: this.getSelectableRange(),
        // onPick: ({ date }) => {
        //   if (date) {
        //     this.$nextTick(() => {
        //       this.handleDateSelection(date);
        //     });
        //   }
        // }
      };
    }
  },
  mounted() {
    this.materialKey = [this.$route.query.materialKey][0];
    if(this.materialKey){
      this.state=this.$route.query.type;
    }
    this.$Http_Post('management/getContentDetails',{MaterialKey:this.materialKey}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.ruleForm.MaterialName = res.Data.materialName;
        this.timisngs=res.Data.scheduledRelease?'2':'1';
        this.ScheduledRelease=res.Data.scheduledRelease;
        this.ruleForm.ChineseAndEnglish=res.Data.rotatLanguage;
        this.imageUrl = res.Data.materialPath;
        this.ruleForm.Type=res.Data.rotatChartType; 
        this.ruleForm.SourceFlg=res.Data.sourceFlg;
        this.ruleForm.JumpContentLink=res.Data.jumpContentLink
      } else {
        this.Global.request_failure(res.Message);
      }
    })
  },
  methods: {
    // ==== 新增：日期选择处理 ====
    handleDateSelection(date) {
      const now = new Date();
      const selected = new Date(date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      selected.setHours(0, 0, 0, 0);
      
      let newDateTime;
      
      if (selected.getTime() === today.getTime()) {
        // 选择今天，直接使用当前时间
        newDateTime = new Date();
      } else {
        // 选择未来日期，设置为上午9点
        newDateTime = new Date(date);
        newDateTime.setHours(9, 0, 0, 0);
      }
      
      this.ScheduledRelease = newDateTime;
    },

    // ==== 新增：获取可选择的时间范围 ====
    getSelectableRange() {
      const now = new Date();
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      if (!this.ScheduledRelease || this.timisngs !== '2') {
        return ['00:00:00 - 23:59:59'];
      }
      
      try {
        const selectedDate = new Date(this.ScheduledRelease);
        const selectedDay = new Date(selectedDate);
        selectedDay.setHours(0, 0, 0, 0);
        
        if (selectedDay.getTime() === today.getTime()) {
          const currentHour = now.getHours();
          const currentMinute = now.getMinutes();
          
          let startHour = currentHour;
          let startMinute = currentMinute;
          
          const startTime = `${startHour.toString().padStart(2, '0')}:${startMinute.toString().padStart(2, '0')}:00`;
          return [`${startTime} - 23:59:59`];
        }
      } catch (error) {
        console.warn('日期解析错误:', error);
      }
      
      return ['00:00:00 - 23:59:59'];
    },
    // ==== 新增：日期时间变化处理（重要！）====
    handleDateTimeChange(value) {
      // 当用户手动选择时间时，确保时间有效性
      if (value && this.timisngs === '2') {
        const selectedDate = new Date(value);
        const now = new Date();
        
        // 检查选择的日期是否是今天
        const selectedDay = new Date(selectedDate);
        selectedDay.setHours(0, 0, 0, 0);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        // 只有当选择的是今天，并且时间早于当前时间时才进行调整
        if (selectedDay.getTime() === today.getTime() && selectedDate.getTime() < now.getTime()) {
          const adjustedDate = new Date();
          this.ScheduledRelease = adjustedDate;
        }
      }
    },
    submitForm(formName) {//创建
      if(this.ruleForm.SourceFlg==2 && this.ruleForm.Type==''){
        this.$message.error('请选择内部跳转');
        return;
      }
      this.iscontinuous = true;
      var from = new FormData();
      this.ScheduledRelease=this.timisngs==1 || this.timisngs==''?'':this.ScheduledRelease;
      from.append('MaterialName', this.ruleForm.MaterialName);
      from.append('IsActive',1);
      from.append('ChineseAndEnglish', this.ruleForm.ChineseAndEnglish);
      from.append('Type', this.ruleForm.Type);
      from.append('JumpContentLink', this.ruleForm.JumpContentLink);
      from.append('SourceFlg', this.ruleForm.SourceFlg);
      from.append('ScheduledRelease', this.ScheduledRelease);
      from.append('MaterialKey', this.materialKey);
      from.append('Operate', 2);
      from.append('pictureFile',this.pictureFile.raw?this.pictureFile.raw:this.imageUrl);
      if(this.state==1){
        from.append('AuditStatus', this.AuditStatus);
        if(this.AuditStatus==2){
        from.append('ReasonRejection', this.ReasonRejection);
        }
      }
      this.$Http_Post('/management/homeChart',from, {'Content-Type': 'multipart/form-data'}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.drawer = false;
          this.iscontinuous = false;
          this.Global.request_successful(res.Message);
          this.$router.go(-1);
        } else {
          this.iscontinuous = false;
          this.Global.request_failure(res.Message);
        }
      })
    },

    handleChange(file, fileList) {
      if (file.raw.type == 'image/jpeg' || file.raw.type == 'image/gif' || file.raw.type == 'image/png') {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.pictureFile = file;
      } else {
        this.$message({ type: 'error', message: '文件格式错误，请上传图片' })
      }
    },

    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },

    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 8;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
  },
}
</script>
<style>
.Material_management_edit{width: 100%;height: 100%;background-color: #fff;overflow: auto;}
.Material_management_edit .avatar-uploader .el-upload:hover {border-color: #409eff;}
.Material_management_edit .avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 215px;height: 148px;line-height: 148px;text-align: center;border: 1px solid #d1d1d1;}
.Material_management_edit .avatar {width: 215px;height: 148px;display: block;}
.Material_management_edit .cover {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;height: 175px;}
.Material_management_edit .avatar-uploader {position: absolute;top: 0px;left: 0px;}
.Material_management_edit .cover p {font-size: 14px;color: rgba(158, 158, 158, 1);position: absolute;top: 0px;left: 330px;width: 350px;}
.Material_management_edit .scale {margin-top: 30px;max-height: 333px;overflow: overlay;}
.Material_management_edit .scale,.scale0 {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;max-height: 333px;overflow: overlay;}
</style>
